<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("TITLES.addClient") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #26a1d6">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <div class="single_step_form_content_wrapper">
      <ValidationObserver v-slot="{ invalid }">
        <form @submit.prevent="validateFormInputs">
          <div class="row">
            <ValidationProvider
              name="الصورة"
              rules="required"
              v-slot="{ errors }"
              class="col-12"
            >
              <base-image-upload-input
                col="12"
                identifier="image"
                :placeholder="$t('PLACEHOLDERS.image')"
                @selectImage="selectImage"
                :errors="errors[0]"
              />
            </ValidationProvider>

            <ValidationProvider
              :name="$t('PLACEHOLDERS.name')"
              rules="required"
              v-slot="{ errors }"
              class="col-6"
            >
              <base-input
                col="12"
                type="text"
                :placeholder="$t('PLACEHOLDERS.name')"
                v-model="data.name"
                :errors="errors[0] || nameServerError"
                @input="nameServerError = null"
                required
              />
            </ValidationProvider>

            <ValidationProvider
              :name="$t('PLACEHOLDERS.email')"
              rules="email"
              v-slot="{ errors }"
              class="col-6"
            >
              <base-input
                col="12"
                type="text"
                :placeholder="$t('PLACEHOLDERS.email')"
                v-model.trim="data.email"
                @input="emailServerError = null"
                :errors="errors[0] || emailServerError"
              />
            </ValidationProvider>

            <ValidationProvider
              :name="$t('PLACEHOLDERS.phone')"
              rules="required|phone"
              v-slot="{ errors }"
              class="col-6"
            >
              <base-input
                col="12"
                type="number"
                :placeholder="$t('PLACEHOLDERS.phone')"
                v-model.trim="data.mobile"
                @input="mobileServerError = null"
                :errors="errors[0] || mobileServerError"
                required
              />
            </ValidationProvider>
            <ValidationProvider
              :name="$t('PLACEHOLDERS.whatsapp')"
              rules="required|phone"
              v-slot="{ errors }"
              class="col-6"
            >
              <base-input
                col="12"
                type="number"
                :placeholder="$t('PLACEHOLDERS.whatsapp')"
                v-model.trim="data.whatsapp"
                :errors="errors[0]"
                required
              />
            </ValidationProvider>
            <input
              type="text"
              name="fake-user"
              style="display: none"
              autocomplete="username"
            />
            <input
              type="password"
              name="fake-pass"
              style="display: none"
              autocomplete="new-password"
            />

            <ValidationProvider
              :name="$t('PLACEHOLDERS.password')"
              rules="required|custom_password"
              v-slot="{ errors }"
              class="col-6"
            >
              <base-input
                col="12"
                type="password"
                :placeholder="$t('PLACEHOLDERS.password')"
                v-model.trim="data.password"
                :errors="errors[0]"
                required
              />
            </ValidationProvider>

            <ValidationProvider
              :name="$t('PLACEHOLDERS.confirmPassword')"
              :rules="{
                required: true,
                password_match: { target: data.password },
              }"
              v-slot="{ errors }"
              class="col-6"
            >
              <base-input
                col="12"
                type="password"
                :placeholder="$t('PLACEHOLDERS.confirmPassword')"
                v-model.trim="data.password_confirmation"
                :errors="errors[0]"
                required
              />
            </ValidationProvider>

            <!-- السويتش -->
            <div class="input_wrapper switch_wrapper my-5 col-12">
              <v-switch
                color="green"
                :label="
                  data.active
                    ? $t('PLACEHOLDERS.active')
                    : $t('PLACEHOLDERS.notActive')
                "
                v-model="data.active"
                hide-details
              ></v-switch>
            </div>

            <!-- الزر -->
            <div class="btn_wrapper col-12 text-end">
              <base-button
                class="mt-2"
                styleType="primary_btn"
                :btnText="$t('BUTTONS.save')"
                :isLoading="isWaitingRequest"
                :disabled="invalid || isWaitingRequest"
              />
            </div>
          </div>
        </form>
      </ValidationObserver>
    </div>
    <!-- END:: Single Step Form Content -->
  </div>
</template>

<script>
export default {
  name: "CreateArea",

  data() {
    return {
      // Start:: Loader Control Data
      isWaitingRequest: false,
      // End:: Loader Control Data

      // Start:: Data Collection To Send
      data: {
        image: {
          path: null,
          file: null,
        },
        name: null,
        email: null,
        mobile: null,
        password: null,
        password_confirmation: null,
        whatsapp: null,
        active: true,
      },
      emailServerError: null,
      mobileServerError: null,
      nameServerError: null,

      // End:: Data Collection To Send
    };
  },

  computed: {
    allTypes() {
      return [
        {
          id: 1,
          name: this.$t("PLACEHOLDERS.subscription"),
          value: "subscription",
        },
        {
          id: 2,
          name: this.$t("PLACEHOLDERS.commission"),
          value: "commission",
        },
      ];
    },
  },

  methods: {
    selectImage(selectedImage) {
      this.data.image = selectedImage;
    },
    // Start:: validate Form Inputs
    validateFormInputs() {
      this.isWaitingRequest = true;
      if (!this.data.name) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.name"));
        return;
      } else if (!this.data.mobile) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.mobile"));
        return;
      } else {
        this.submitForm();
        return;
      }
    },
    setServerError(field, error) {
      this[`${field}ServerError`] =
        error?.response?.data?.errors?.[field]?.[0] || null;
    },
    // Start:: Submit Form
    async submitForm() {
      const REQUEST_DATA = new FormData();

      if (this.data.image.file) {
        REQUEST_DATA.append("avatar", this.data.image.file);
      }
      REQUEST_DATA.append("role", 2);
      REQUEST_DATA.append("name", this.data.name);
      if (this.data.email) REQUEST_DATA.append("email", this.data.email);
      REQUEST_DATA.append("mobile", this.data.mobile);
      REQUEST_DATA.append("whatsapp", this.data.whatsapp);

      if (this.data.password) {
        REQUEST_DATA.append("password", this.data.password);
      }
      if (this.data.password_confirmation) {
        REQUEST_DATA.append(
          "password_confirmation",
          this.data.password_confirmation
        );
      }
      REQUEST_DATA.append("is_active", this.data.active ? 1 : 0);
      // Start:: Append Request Data

      try {
        await this.$axios({
          method: "POST",
          url: `users`,
          data: REQUEST_DATA,
        });
        this.isWaitingRequest = false;
        this.$message.success(this.$t("MESSAGES.addedSuccessfully"));
        this.$router.push({ path: "/clients/all" });
      } catch (error) {
        this.isWaitingRequest = false;
        this.setServerError("email", error);
        this.setServerError("mobile", error);
        this.setServerError("name", error);
        this.$message.error(error.response.data.message);
      }
    },
    // End:: Submit Form
  },

  async created() {},
};
</script>
